/*
 * @Author: Viviyaaaa 870951135@qq.com
 * @Date: 2024-04-10 11:40:28
 * @LastEditors: Viviyaaaa 870951135@qq.com
 * @LastEditTime: 2024-04-13 22:20:42
 * @FilePath: \demo\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import Swiper from 'swiper';
import store from './store.js'
// import "@/utils/flexible.js";
import './swiper/swiper-bundle.min.css';

// 定义中央事件总线
const EventBus = new Vue()
Vue.config.productionTip = false
Vue.prototype.$EventBus = EventBus


new Vue({
  store,
  render: h => h(App),
  install: function() {
    // 将Swiper添加到Vue的原型，这样你可以在任何组件中通过this.$swiper访问
    Vue.prototype.$swiper = Swiper;
  },
  beforeCreate() {
    // bus 总线
    // $ 为了迎合 vue 的命名习惯
    // 安装全局事件总线，$bus就是当前应用的vm
    Vue.prototype.$bus = this
  }
}).$mount('#app')
